import { ReactNode, useContext } from "react";
import {
  AppBar,
  Typography,
  Toolbar,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { AppContext } from "context/appContext";
import { MOBILE_LAYOUT } from "context/themeContext";
const MobileNavBar = (): ReactNode => {
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"));
  const { state } = useContext(AppContext);

  return (
    <AppBar color="secondary" position={"fixed"} elevation={0}>
      <Toolbar
        disableGutters
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: MOBILE_LAYOUT.navbarHeight,
          border: 0,
          borderBottom: 2,
          borderBottomColor: theme.palette.primary.main,
          borderStyle: "solid",
          position: "relative",
        }}
      >
        <Typography
          align="center"
          sx={{ width: "100%" }}
          color={theme.palette.secondary.contrastText}
          variant={isPhone ? "h3" : "h2"}
        >
          {`${state.headerText}`}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default MobileNavBar;
